import { ToasterService } from 'angular2-toaster';

export const EMPLOYEE_NO_ERROR_MSG = 'Please enter a valid Employee No. It must be exactly 6 digits, numbers only.';

export function isEmployeeNoValidationEnabled(flag: any): boolean {
  return flag === true || flag === '1' || flag === 1;
}

export function isEmployeeNoTypingAllowed(value: string): boolean {
  return value === '' || /^[1-9][0-9]{0,5}$/.test(value);
}

export function isEmployeeNoComplete(value: any): boolean {
  if (value == null || value === undefined || String(value) === '') {
    return true;
  }
  return /^[1-9][0-9]{5}$/.test(String(value));
}

export function validateAllocateEmployeeNoList(isVisible: boolean, list: any[], toaster: ToasterService, enableEmployeeNoValidation?: any): boolean {
  if (!isEmployeeNoValidationEnabled(enableEmployeeNoValidation) || !isVisible || !list) {
    return true;
  }
  for (let i = 0; i < list.length; i++) {
    if (!isEmployeeNoComplete(list[i].employee_code)) {
      toaster.pop('info', 'Info', EMPLOYEE_NO_ERROR_MSG);
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// /codebuild/output/src1860559092/src/src/app/shared/utils/employee-no.util.ts